import { parseSiteBriefSummary } from './siteBriefSummary';

export type SummaryLine = { kind: 'heading' | 'paragraph' | 'point'; text: string };
export type SummaryEditDraft = { before: string; after: string };
export type SummaryAction = { summary_action: 'reveal' | 'edit'; summary_before?: string };

export const summaryLines = (summary: string): SummaryLine[] => parseSiteBriefSummary(summary).flatMap<SummaryLine>((block) =>
  block.kind === 'list' ? block.items.map((text) => ({ kind: 'point' as const, text: text.replace(/\*\*/g, '') }))
    : [{ kind: block.kind, text: block.text.replace(/\*\*/g, '') }],
);

export const serializeSummaryLines = (lines: SummaryLine[]): string => lines.map((line) =>
  `${line.kind === 'heading' ? '## ' : line.kind === 'point' ? '- ' : ''}${line.text}`,
).join('\n\n');

const COPY = {
  uk: {
    title: 'Ось яким буде ваш сайт', hint: 'Натисніть на текст, щоб змінити його. Видалення пункту скасує відповідну вимогу.',
    build: 'Створити сайт', review: 'Переглянути й створити', continueChat: 'Продовжити чат', save: 'Зберегти зміни',
    discard: 'Скасувати зміни', saved: 'Збережено', unsaved: 'Є незбережені зміни', remove: 'Видалити', add: 'Додати пункт', addSection: 'Додати розділ',
    newPoint: 'Нова деталь', newSection: 'Новий розділ', edit: 'Редагувати',
    revealMessage: 'Покажіть поточний підсумок — хочу перейти до створення сайту.',
  },
  en: {
    title: 'Here is the plan for your website', hint: 'Click any text to edit it. Removing a point cancels that requirement.',
    build: 'Build a site', review: 'Review and build', continueChat: 'Continue chat', save: 'Save changes',
    discard: 'Discard changes', saved: 'Saved', unsaved: 'Unsaved changes', remove: 'Remove', add: 'Add a point', addSection: 'Add a section',
    newPoint: 'New detail', newSection: 'New section', edit: 'Edit',
    revealMessage: 'Show me the current summary. I would like to move on to building my site.',
  },
  ru: {
    title: 'Вот каким будет ваш сайт', hint: 'Нажмите на текст, чтобы изменить его. Удаление пункта отменит соответствующее требование.',
    build: 'Создать сайт', review: 'Посмотреть и создать', continueChat: 'Продолжить чат', save: 'Сохранить изменения',
    discard: 'Отменить изменения', saved: 'Сохранено', unsaved: 'Есть несохранённые изменения', remove: 'Удалить', add: 'Добавить пункт', addSection: 'Добавить раздел',
    newPoint: 'Новая деталь', newSection: 'Новый раздел', edit: 'Редактировать',
    revealMessage: 'Покажите текущий итог — хочу перейти к созданию сайта.',
  },
  es: {
    title: 'Así será tu sitio web', hint: 'Pulsa cualquier texto para editarlo. Eliminar un punto cancela ese requisito.',
    build: 'Crear el sitio', review: 'Revisar y crear', continueChat: 'Seguir conversando', save: 'Guardar cambios',
    discard: 'Descartar cambios', saved: 'Guardado', unsaved: 'Cambios sin guardar', remove: 'Eliminar', add: 'Añadir un punto', addSection: 'Añadir una sección',
    newPoint: 'Nuevo detalle', newSection: 'Nueva sección', edit: 'Editar',
    revealMessage: 'Muéstrame el resumen actual. Quiero pasar a crear mi sitio.',
  },
};

export function summaryReviewCopy(language: string) {
  const primary = language.toLowerCase().split(/[-_]/)[0];
  return COPY[(primary === 'ua' ? 'uk' : primary) as keyof typeof COPY] ?? COPY.en;
}
